<template>
  <a-modal
    @cancel="cancel"
    v-model:visible="visible"
    destroyOnClose
    :footer="null"
    width="85%"
    :bodyStyle="{
      minHeight: '80vh'
    }"
  >
    <template #title>
      <div>
        近期待办
        <span style="font-size: 16px; color: #000000d9">{{ totalTodoNum }}</span>
      </div>
    </template>
    <div class="modal">
      <a-spin :spinning="orderFetching">
        <a-tabs :animated="false" v-model:activeKey="activeKey" class="patient-tabs" type="card">
          <a-tab-pane :key="tab.key" :tab="renderTabTitle(tab)" v-for="tab in todoModalTab">
            <component
              v-if="activeKey === tab.key"
              mode="read"
              :is="tab.component"
              class="detailComponent"
            />
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, computed } from 'vue'
import { todoModalTab } from '@/components/PatientFile/ModalBody/todo/config'
import { useStore } from 'vuex'

const orderFetching = ref(false)
const visible = ref(false)
const activeKey = ref(1)
const store = useStore()

const todoNums = computed(() => store.getters.todoNums)
const totalTodoNum = computed(() => store.getters.totalTodoNum)

// 渲染 tab 标题（带数量）
const renderTabTitle = tab => {
  const count = todoNums.value[tab.ref] || 0
  return `${tab.label} ${count}`
}

const openMatch = () => {
  visible.value = true
}

const cancel = () => {
  visible.value = false
  activeKey.value = 1
}

// 暴露给父组件调用的方法
defineExpose({
  openMatch
})
</script>

<style lang="scss" scoped></style>
